import { createCustomEventSystem } from '@frontend/event';

interface WaitlistCustomEvents {
  'schedule:waitlist:set-context': {
    locationId?: string;
    selectedDate?: string; // YYYY-MM-DD
    selectedTime?: string; // hh:mm A
    providerId?: string;
  };
  'schedule:waitlist:person-added': { personId: string };
}

const {
  triggerCustomEvent: triggerWaitlistCustomEvent,
  useCustomEventListener: useWaitlistCustomEventListener,
  addCustomEventListener: addWaitlistCustomEventListener,
} = createCustomEventSystem<WaitlistCustomEvents>();

export { triggerWaitlistCustomEvent, useWaitlistCustomEventListener, addWaitlistCustomEventListener };
